module.exports = __webpack_public_path__ + "img/valor23e54.bbbe88bd.png";